import React, { Suspense, useState } from 'react';
import LazyLoad, { lazyload } from 'react-lazyload';
import { Lottie } from '@crello/react-lottie';

import Head from 'next/head';

import st from './index.module.scss';

import Pricing from '../../../components/video-production/Pricing';
import BradCrumbs from '../../../components/Base/BradCrumbs';
import Engagement from '../../../components/Engagement';
import Faq from '../../../components/Faq';
import typesLottie from '../../../public/images/types.json';
import Why from '../../../components/Why';
import ViewMore from '../../../components/ViewMore';
import BenefitsWebsite from '../../../components/video-production/explainer-videos/BenefitsWebsite';
import ProcessSliderWebsite from '../../../components/sliders/ProcessSliderWebsite';
import SolveProblemsWebsite from '../../../components/video-production/explainer-videos/SolveProblemsWebsite';

lazyload({
  width: '100%',
});

const ExplainerVideosWebsite = props => {
  const [showPricingModalF, setShowPricingModalF] = useState(false);
  const [videoLength, setVideoLength] = useState([]);
  const [script, setScript] = useState([]);

  const showPricingModal = () => {
    if (props.width < 768) {
      window.location.href = '/video-production/get-pricing';
    } else {
      setShowPricingModalF(true);
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      window.location.hash = 'open';
    }
  };
  const hidePricingModal = () => {
    setShowPricingModalF(false);
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    history.replaceState(null, null, ' ');
    document.documentElement.style.overflow = 'auto';
  };

  return (
    <>
      <Head>
        <title>Video Production - Website Explainer Video | Prodigi</title>
        <link rel="alternate" hrefLang="en" href="https://weprodigi.com/video-production/website-explainer-video" />
        <meta
          name="description"
          content="Increase traffic with a captivating website explainer video. Our expertly crafted videos drive conversions and simplify complex ideas. Learn more with us."
        />
        <meta property="og:url" content="https://weprodigi.com/video-production/website-explainer-video" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Video Production - Website Explainer Video | Prodigi" />
        <meta
          property="og:description"
          content="Increase traffic with a captivating website explainer video. Our expertly crafted videos drive conversions and simplify complex ideas. Learn more with us."
        />
        <meta property="og:image" content="https://weprodigi.com/uploads/images/explainer-videos/website-explainer/og.jpg" />
        <script
          type="application/ld+json"
          className="organization-schema"
          dangerouslySetInnerHTML={{
            __html: `{
              "@context": "http://schema.org",
              "@type": "WebPage",
              "name": "Video Production - Website Explainer Video | Prodigi",
              "description": "Increase traffic with a captivating website explainer video. Our expertly crafted videos drive conversions and simplify complex ideas. Learn more with us.",
              "url": "https://weprodigi.com/video-production/website-explainer-video",
              "breadcrumb": {
                "@type": "BreadcrumbList",
                "itemListElement": [
                  {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Home",
                    "item": "https://weprodigi.com"
                  },
                  {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Full Service Video Production",
                    "item": "https://weprodigi.com/video-production"
                  },
                  {
                    "@type": "ListItem",
                    "position": 3,
                    "name": "Website Explainer Video Production - Prodigi",
                    "item": "https://weprodigi.com/video-production/website-explainer-video"
                  }
                ]
              },
              "mainEntity": {
                "@type": "Product",
                "name": "Website Explainer Video Production",
                "description": "Increase traffic with a captivating website explainer video. Our expertly crafted videos drive conversions and simplify complex ideas. Learn more with us.",
                "brand": {
                  "@type": "Brand",
                  "name": "Weprodigi"
                },
                "offers": {
                  "@type": "Offer",
                  "price": "1300",
                  "priceCurrency": "USD",
                  "seller": {
                    "@type": "Organization",
                    "name": "Weprodigi"
                  }
                },
                "image": "https://weprodigi.com/images/logovertical.svg",
                "review": [
                  {
                    "@type": "Review",
                    "reviewRating": {
                      "@type": "Rating",
                      "ratingValue": "5",
                      "bestRating": "5",
                      "worstRating": "1"
                    },
                    "author": {
                      "@type": "Person",
                      "name": "Peter Moris"
                    },
                    "datePublished": "2023-03-05",
                    "reviewBody": "I absolutely loved the explainer video on this website! It's rare to come across a video that manages to be informative and entertaining at the same time, but this one nailed it. It's obvious that a lot of thought and creativity went into making it. Two thumbs up!"
                  },
                  {
                    "@type": "Review",
                    "reviewRating": {
                      "@type": "Rating",
                      "ratingValue": "5",
                      "bestRating": "5",
                      "worstRating": "1"
                    },
                    "author": {
                      "@type": "Person",
                      "name": "Stella Novikov"
                    },
                    "datePublished": "2023-10-23",
                    "reviewBody": "Wow, just wow! That explainer video on the website blew me away. Not only was it visually stunning, but it also did an incredible job of breaking down complex concepts into simple, easy-to-understand terms. I'm really impressed and thankful."
                  },
                  {
                    "@type": "Review",
                    "reviewRating": {
                      "@type": "Rating",
                      "ratingValue": "4.9",
                      "bestRating": "5",
                      "worstRating": "1"
                    },
                    "author": {
                      "@type": "Person",
                      "name": "Andy Wood"
                    },
                    "datePublished": "2024-02-20",
                    "reviewBody": "As someone who often finds myself confused by new websites, I was pleasantly surprised by how helpful the website explainer video was. It walked me through everything I needed to know in a way that was easy to follow and entertaining.Thank You Prodigi!"
                  }
                ],
                "aggregateRating": {
                  "@type": "AggregateRating",
                  "ratingValue": "4.9",
                  "reviewCount": "3"
                }
              }
            }                                   
            `,
          }}
        />
      </Head>

      {/*    Header video */}
      <div className={`relative w-full  h-intro  overflow-hidden  `}>
        <video
          width="100%"
          height="100%"
          autoPlay
          loop
          muted
          playsInline
          preload="none"
          id="header-11"
          className={'absolute h-intro md:h-full ' + st['header-mp4']}
        >
          <source src="https://weprodigi.com/uploads/images/explainer-videos/website-explainer/website-explainer.mp4" type="video/mp4" />
        </video>
        <div className={st['overlay']}></div>
        <div className="container h-full">
          <div className="relative h-full  flex flex-col flex-wrap justify-center items-start overflow-hidden">
            <h1 className="max-w-300 md:max-w-600 uppercase md:normal-case text-white text-30 md:text-72 font-black md:font-bold leading-tight">
              Website Explainer Video Production
            </h1>
            <a
              onClick={showPricingModal}
              className="relative flex items-center justify-center min-w-250 z-10 border-2 rounded-5 border-green-badge hover:border-green-hover text-18 text-white px-23 mt-48 md:mt-23 py-8 bg-green-badge hover:bg-green-hover hover:text-white transition-all   transition-400 cursor-pointer"
            >
              Get Pricing
              <img src="https://weprodigi.com/uploads/images/explainer-videos/buttonIcon.svg" className={'ml-10'} alt="pricing icon" />
            </a>
          </div>
        </div>
      </div>

      <div className="bg-white">
        <div className="container">
          <BradCrumbs
            items={[
              {
                url: '/video-production',
                name: 'Video Production',
              },
              {
                url: '/video-production/explainer-videos',
                name: 'Explainer Video Production',
              },
              {
                url: '/video-production/website-explainer-video',
                name: 'Website Explainer Video',
              },
            ]}
          />
          <div className="relative pt-20 md:pt-0 pb-48">
            <div className="flex flex-wrap md:flex-nowrap justify-between">
              <LazyLoad className="mr-auto mt-24 md:mt-0 max-w-270 w-full md:w-auto" height={200} once>
                <Lottie
                  config={{
                    animationData: typesLottie,
                    loop: true,
                    autoPlay: true,
                  }}
                  playingState="playing"
                />
              </LazyLoad>
              <div className="flex flex-col ml-12 items-center justify-center max-w-756">
                <Engagement title="Video">
                  A website explainer video will uncover the secret to success of your project in your website. Visualise the purposes of your product
                  within 1-3 minutes by crafting the primary information. Scroll down to keep up with main trends!
                </Engagement>
              </div>
            </div>
          </div>
        </div>
      </div>

      <LazyLoad height={200} once>
        <div className={'bg-gray-white py-24'}>
          <div className="container">
            <h2 className={'w-full lg:w-half-auto font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              What Is a Website Explainer Video?
            </h2>

            <div className={'block md:flex justify-between flex-row md:flex-row-reverse'}>
              <div className=" pl-0 md:pl-20 pb-10 w-full md:w-half-auto block  mt-23 mb-10">
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/CyF7-rDqjGA?controls=0"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Matador Broadcast | Website Explainer Video</p>
              </div>

              <p className={'mt-20 w-half-auto hidden md:block'}>
                A website explainer video is a short, engaging video for a description of a product or a service on the website. It’s an effective
                tool to develop your website story. It explains concepts by simplifying them. Using this video format increases conversion rates and
                user engagement.
              </p>
              <div className={'mt-20 block md:hidden'}>
                <ViewMore ln={40}>
                  A website explainer video is a short, engaging video for a description of a product or a service on the website. It’s an effective
                  tool to develop your website story. It explains concepts by simplifying them. Using this video format increases conversion rates and
                  user engagement.
                </ViewMore>
              </div>
            </div>
            <br className={'clear-both hidden'} />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className={'w-full md:w-75p font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              Where to Use Website Explainer Video?
            </h2>
            <p className={'mt-20'}>
              Discover the diverse ways you can use a site overview video to improve your online visibility. Discover the main benefits for each
              industry.
            </p>

            <div className="flex flex-wrap-reverse md:flex-nowrap justify-between items-start mt-0 md:mt-24">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/-Tl2cdXnB_A?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Perkin Elmer | 2D Animation Explainer Video</p>
              </div>

              <div className={'w-full md:w-half-auto mt-24 md:mt-0'}>
                <h3 className="text-purple font-bold text-24   leading-none">Marketing and Advertising</h3>
                <div className={'mt-16 hidden md:block'}>
                  Explainer videos for websites are a powerful addition to your marketing strategy. The use of these videos in your website, brings
                  visibility to your products, and improves your website’s SEO. Moreover, it gives the opportunity of introducing your product in the
                  website’s homepage or landing page.Videos on your website drive better marketing results by improving user experience and search
                  engine visibility.
                </div>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={40}>
                    Explainer videos for websites are a powerful addition to your marketing strategy. The use of these videos in your website, brings
                    visibility to your products, and improves your website’s SEO. Moreover, it gives the opportunity of introducing your product in
                    the website’s homepage or landing page.Videos on your website drive better marketing results by improving user experience and
                    search engine visibility.
                  </ViewMore>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap md:flex-nowrap justify-between mt-0 md:mt-48">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <h3 className="text-purple font-bold text-24 leading-none">Software and Technology</h3>
                <p className={'mt-16'}></p>

                <p className={'mt-16 hidden md:block'}>
                  An explainer video brings better SEO performance to your website. Make your captivating showcase of products or services visible. A
                  digital property explainer video helps with the community-building processes by simplifying concepts. Share the benefits and the
                  uniqueness of your product interactively.
                </p>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={40}>
                    An explainer video brings better SEO performance to your website. Make your captivating showcase of products or services visible.
                    A digital property explainer video helps with the community-building processes by simplifying concepts. Share the benefits and the
                    uniqueness of your product interactively.
                  </ViewMore>
                </div>
              </div>
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/CXKUM60vo8o?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Createvolve | 2D Animation Explainer Video</p>
              </div>
            </div>
            <div className="flex flex-wrap-reverse md:flex-nowrap justify-between mt-24 md:mt-48">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/GcfJTZiAmd4?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Status Card | Website Explainer Video</p>
              </div>

              <div className={'w-full md:w-half-auto '}>
                <h3 className="text-purple font-bold text-24 leading-none">Finance and Banking</h3>
                <p className={'mt-16 hidden md:block'}>
                  With many services now available online, your customers must know how to use your digital tools. Upgrading your websites with an
                  online platform tutorial is a perfect solution to this challenge. It increases your company's offerings and community engagement.
                  Simplified information about investments, loans, mortgages, or retirement plannings will be trust-building. Inform your customers
                  and develop your website at the same time.
                </p>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={'40'}>
                    With many services now available online, your customers must know how to use your digital tools. Upgrading your websites with an
                    online platform tutorial is a perfect solution to this challenge. It increases your company's offerings and community engagement.
                    Simplified information about investments, loans, mortgages, or retirement plannings will be trust-building. Inform your customers
                    and develop your website at the same time.
                  </ViewMore>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-gray-light py-24'}>
          <div className="container">
            <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              Benefits of Website Explainer Videos
            </h2>
            <p className={'mt-20'}>Ready to improve the effectiveness of your website? Here are the main benefits of website explainer video.</p>
            <Suspense fallback={`Loading...`}>
              <BenefitsWebsite />
            </Suspense>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-white">
          <div className="container py-23">
            <h2 className="text-purple text-24 md:text-36 text-left mb-23 font-black uppercase leading-none">
              Our Website Explainer Video Production Process
            </h2>
            <ProcessSliderWebsite />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={0} once>
        <div className={'h-500 md:h-310 overflow-hidden relative ' + st['bg-contact']}>
          <div id="stars" />
          <div id="stars2" />
          <div id="stars3" />
          <div className="container flex flex-wrap md:flex-nowrap justify-between items-end md:items-center h-full ">
            <div
              className={
                'mt-24 md:mt-0 text-left md:text-center font-bold uppercase  text-white leading-28 md:leading-44   text-20 md:text-26 lg:text-36'
              }
            >
              CALCULATE YOUR WEBSITE EXPLAINER VIDEO PRICE
              <br />
              <span className={'pt-20 font-normal normal-case text-18 md:text-24 leading-20 md:leading-29 '}>
                Answer five questions and get to know the price!
              </span>
              <div className={'flex justify-end md:justify-center mt-0 leading-0'}>
                <button
                  onClick={showPricingModal}
                  className="uppercase h-40 text-18 leading-24  hover:bg-green-hover md:flex justify-center items-center   w-auto mt-24 text-white bg-green rounded-5 px-23 py-0 md:py-5"
                >
                  Start Now
                </button>
              </div>
            </div>
            <img src="https://weprodigi.com/uploads/images/explainer-videos/Inga.webp" alt="eva" className={st['inga']} />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              How Website Explainer Videos Can Help Your Business?
            </h2>
            <p className={'mt-20'}>
              Website explainer video is a multi-level strategic tool for community building and engaging audiences. Scroll down to know how it will
              visualise your business goals.
            </p>
            <Suspense fallback={`Loading...`}>
              <SolveProblemsWebsite />
            </Suspense>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-gray-light">
          <div className="container py-23">
            <h2 className="uppercase text-30 md:text-36 mb-23 font-black text-purple leading-none">
              Why Choose Us for Your Website Explainer Video Production?
            </h2>
            <Why
              content={[
                {
                  title: 'We value your time',
                  answer:
                    'We know how important our clients’ time is. Outsourcing full service video production helps save your expensive time. More importantly, we quickly understand your business needs and implement our proven time-saving solutions at all stages of production, from communication to payment methods.',
                },
                {
                  title: 'We include digital marketing specialists in the production process',
                  answer:
                    "According to Google, 6 out of 10 people are keener on watching videos online rather than TV. To create an effective video, you need to consider on which platform the video will be used and master all its features of, be it your website, Youtube, Facebook, or Amazon. That's why we include our digital marketing specialists in the production process, who study your business requirements in detail and combine them with the requirements of each of the online platforms to get effective material in the end result.",
                },
                {
                  title: 'We don’t require prepayment',
                  answer:
                    "We believe that the client should pay for the done work, rather than with deposits. We choose a milestone payment option, as we believe that it's a more trustworthy approach in our work.",
                },
                {
                  title: 'We don’t have a single unhappy client',
                  answer:
                    'We never charge for a product that is not approved by you. If you are not satisfied with the results, 100% money-back is guaranteed.',
                },
              ]}
            />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-white">
          <div className="container py-23">
            <h2 className="uppercase text-24 md:text-36 mb-23 font-black text-purple leading-none">FAQ</h2>
            <div className="grid md:grid-cols-2 md:gap-30">
              <Faq
                content={[
                  {
                    title: 'What is the purpose of a website explainer video?',
                    answer: "The purpose of a website explainer video is to highlight a company's product or service through a website.",
                  },
                  {
                    title: 'Why should I use a website explainer video?',
                    answer: 'A website explainer video reduces the number of support queries and improves engagement of your audience.',
                  },
                ]}
              />
              <Faq
                content={[
                  {
                    title: 'How to make a website explainer video?',
                    answer:
                      'Engaging script, catchy visualisation and professional voiceover, and excellent sound effects are the key points of making a good website explainer video.',
                  },
                  {
                    title: 'How long should a website explainer video be?',
                    answer:
                      'The shorter and more dynamic, the better. The optimal length for a website explainer video is between 45 seconds and 1 minute.',
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </LazyLoad>

      <Pricing videoLength={videoLength} script={script} country={props.country} show={showPricingModalF} hide={hidePricingModal} step={1} />
    </>
  );
};

export default ExplainerVideosWebsite;
